import AppDatePicker from '@nxsys/components/AppDatePicker';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppSelect from '@nxsys/components/AppSelect';
import { finalSubmitTypeOptions } from '@nxsys/constants/AppConstants';
import { Option } from '@nxsys/types/models/Common';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import { Moment } from 'moment';
import React, { useEffect, useState } from 'react';

type Props = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: SubmitFinalFPSValues) => Promise<void>;
  defaultValues?: Partial<SubmitFinalFPSValues>;
};

export type SubmitFinalFPSValues = {
  finalSubmitType: Option<string> | null;
  dateSchemeCeased: Moment | null;
};

const SubmitFinalFPSModal: React.FC<Props> = ({
  isOpen,
  toggle,
  onSubmit,
  defaultValues = {},
}) => {
  const [form] = Form.useForm();
  const watchValues = Form.useWatch([], form);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(defaultValues);
    }
  }, [isOpen, defaultValues]);

  const onFinish: FormProps['onFinish'] = (values) => {
    setIsSubmitting(true);
    onSubmit(values)
      .then(() => {
        toggle();
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title="Submit FPS"
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: 'Cancel',
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: 'Submit',
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Form.Item
          label="Final Submit Type"
          name="finalSubmitType"
          rules={[
            {
              required: true,
              message: 'Please enter',
            },
          ]}
        >
          <AppSelect
            options={finalSubmitTypeOptions}
            placeholder="Select Final Submit Type"
          />
        </Form.Item>
        {watchValues?.finalSubmitType?.value === 'schemeCeased' && (
          <Form.Item
            label="Date Scheme Ceased"
            name="dateSchemeCeased"
            rules={[{ required: true, message: 'Please select' }]}
          >
            <AppDatePicker
              placeholder="Select Date Scheme Ceased"
              format="DD/MM/YYYY"
            />
          </Form.Item>
        )}
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default SubmitFinalFPSModal;
